import React from 'react';
import {makeStyles} from '@material-ui/core';
import {Helmet} from 'react-helmet';
import {PrivacyPageInfo} from '../NavPages';

const useStyles = makeStyles(() => ({
  privacy: {
    textAlign: 'left',
    marginLeft: '5em',
    marginRight: '5em',
  },
}));

const Privacy = () => {
  const classes = useStyles();
  return (
    <div>
      <Helmet>
        <title>{PrivacyPageInfo.title}</title>
        <meta name="description" content={PrivacyPageInfo.description} />
      </Helmet>
      <div className={classes.privacy}>
        <h1>Privacy Policy</h1>
        <p>
          <strong>Last updated June 30, 2022</strong>
        </p>
        <p>
          <span>
            Thank you for choosing to be part of our community at Drink Agenda
            (&quot;
          </span>
          <strong>Drink Agenda</strong>
          <span>&quot;, &quot;</span>
          <strong>we</strong>
          <span>&quot;, &quot;</span>
          <strong>us</strong>
          <span>&quot;, &quot;</span>
          <strong>our</strong>
          <span>
            &quot;). We are committed to protecting your personal information
            and your right to privacy. If you have any questions or concerns
            about this privacy notice, or our practices with regards to your
            personal information, please contact us at legal@drinkagenda.com.
          </span>
        </p>

        <p>
          <span>When you visit our websites </span>
          <a href="https://www.alcanon.com/">
            <span>www.alcanon.com</span>
          </a>
          <span> or </span>
          <a href="https://drinkagenda.com/">
            <span>drinkagenda.com</span>
          </a>
          <span> (the &quot;</span>
          <strong>Websites</strong>
          <span>
            &quot;), use our mobile application, as the case may be (the &quot;
          </span>
          <strong>App</strong>
          <span>
            &quot;) and more generally, use any of our services (the &quot;
          </span>
          <strong>Services</strong>
          <span>&quot;, which include the </span>
          <span>&nbsp;Websites and App </span>
          <span>
            ), we appreciate that you are trusting us with your personal
            information. We take your privacy very seriously. In this privacy
            notice, we seek to explain to you in the clearest way possible what
            information we collect, how we use it and what rights you have in
            relation to it. We hope you take some time to read through it
            carefully, as it is important. If there are any terms in this
            privacy notice that you do not agree with, please discontinue use of
            our Services immediately.
          </span>
        </p>

        <p>
          <span>
            This privacy notice applies to all information collected through our
            Services (which, as described above, includes our Websites and App),
            as well as, any related services, sales, marketing or events.
          </span>
        </p>

        <p>
          <strong>
            Please read this privacy notice carefully as it will help you
            understand what we do with the information that we collect.
          </strong>
        </p>

        <p>
          <strong>TABLE OF CONTENTS</strong>
        </p>

        <ol>
          <li>
            <a href="#infocollect">
              <span> WHAT INFORMATION DO WE COLLECT?</span>
            </a>
          </li>
          <li>
            <a href="#infouse">
              <span> HOW DO WE USE YOUR INFORMATION?</span>
            </a>
          </li>
          <li>
            <a href="#infoshare">
              <span> WILL YOUR INFORMATION BE SHARED WITH ANYONE?</span>
            </a>
          </li>
          <li>
            <a href="#cookies">
              <span> DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</span>
            </a>
          </li>
          <li>
            <a href="#sociallogins">
              <span> HOW DO WE HANDLE YOUR SOCIAL LOGINS?</span>
            </a>
          </li>
          <li>
            <a href="#inforetain">
              <span> HOW LONG DO WE KEEP YOUR INFORMATION?</span>
            </a>
          </li>
          <li>
            <a href="#infosafe">
              <span> HOW DO WE KEEP YOUR INFORMATION SAFE?</span>
            </a>
          </li>
          <li>
            <a href="#infominors">
              <span> DO WE COLLECT INFORMATION FROM MINORS?</span>
            </a>
          </li>
          <li>
            <a href="#privacyrights">
              <span> WHAT ARE YOUR PRIVACY RIGHTS?</span>
            </a>
          </li>
          <li>
            <a href="#DNT">
              <span> CONTROLS FOR DO-NOT-TRACK FEATURES</span>
            </a>
          </li>
          <li>
            <a href="#caresidents">
              <span>
                {' '}
                DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
              </span>
            </a>
          </li>
          <li>
            <a href="#policyupdates">
              <span> DO WE MAKE UPDATES TO THIS NOTICE?</span>
            </a>
          </li>
          <li>
            <a href="#contact">
              <span> HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span>
            </a>
          </li>
          <li>
            <a href="#request">
              <span>
                {' '}
                HOW CAN YOU REVIEW, UPDATE OR DELETE THE DATA WE COLLECT FROM
                YOU?
              </span>
            </a>
          </li>
        </ol>

        <ol id="infocollect">
          <li>
            <strong> WHAT INFORMATION DO WE COLLECT?</strong>
          </li>
        </ol>

        <p>
          <strong>Personal information you disclose to us</strong>
        </p>

        <p>
          <strong>
            <em>In Short:&nbsp; </em>
          </strong>
          <em>
            <span>We collect personal information that you provide to us.</span>
          </em>
        </p>

        <p>
          <span>
            We collect personal information that you voluntarily provide to us
            when you register on the&nbsp; Services, express an interest in
            obtaining information about us or our products and Services, when
            you participate in activities on the Services (such as by posting
            messages in our online forums or entering competitions, contests or
            giveaways)&nbsp; or otherwise when you contact us.
          </span>
        </p>

        <p>
          <span>
            The personal information that we collect depends on the context of
            your interactions with us and the Services , the choices you make
            and the products and features you use. The personal information we
            collect may include the following:
          </span>
        </p>

        <p>
          <strong>Personal Information Provided by You.</strong>
          <span>
            {' '}
            We collect names;&nbsp; email addresses;&nbsp; usernames;&nbsp;
            contact preferences;&nbsp; notes and records;&nbsp; and other
            similar information.
          </span>
        </p>

        <p>
          <strong>Payment Data.</strong>
          <span>
            {' '}
            We may collect data necessary to process your payment if you make
            purchases, such as your payment instrument number (such as a credit
            card number), and the security code associated with your payment
            instrument. All payment data is stored by Google . You may find
            their privacy notice link(s) here:{' '}
          </span>
          <a href="https://policies.google.com/privacy">
            <span>https://policies.google.com/privacy</span>
          </a>
          <span> .</span>
        </p>

        <p>
          <strong>Social Media Login Data. </strong>
          <span>
            We may provide you with the option to register with us using your
            existing social media account details, like your Facebook, Twitter
            or other social media account. If you choose to register in this
            way, we will collect the Information described in the section called
            &quot;
          </span>
          <a href="#sociallogins">
            <span>HOW DO WE HANDLE YOUR SOCIAL LOGINS</span>
          </a>
          <span>&quot; below.</span>
        </p>

        <p>
          <span>
            All personal information that you provide to us must be true,
            complete and accurate, and you must notify us of any changes to such
            personal information.
          </span>
        </p>

        <p>
          <strong>Information automatically collected</strong>
        </p>

        <p>
          <strong>
            <em>In Short:&nbsp; </em>
          </strong>
          <em>
            <span>
              Some information &mdash; such as your Internet Protocol (IP)
              address and/or browser and device characteristics &mdash; is
              collected automatically when you visit our Services .
            </span>
          </em>
        </p>

        <p>
          <span>
            We automatically collect certain information when you visit, use or
            navigate the Services . This information does not reveal your
            specific identity (like your name or contact information) but may
            include device and usage information, such as your IP address,
            browser and device characteristics, operating system, language
            preferences, referring URLs, device name, country, location,
            information about how and when you use our Services and other
            technical information. This information is primarily needed to
            maintain the security and operation of our Services , and for our
            internal analytics and reporting purposes.
          </span>
        </p>

        <p>
          <span>
            Like many businesses, we also collect information through cookies
            and similar technologies.
          </span>
        </p>

        <p>
          <span>The information we collect includes:</span>
        </p>
        <ul>
          <li>
            <em>
              <span>Log and Usage Data.</span>
            </em>
            <span>
              {' '}
              Log and usage data is service-related, diagnostic, usage and
              performance information our servers automatically collect when you
              access or use our Services and which we record in log files.
              Depending on how you interact with us, this log data may include
              your IP address, device information, browser type and settings and
              information about your activity in the Services&nbsp; (such as the
              date/time stamps associated with your usage, pages and files
              viewed, searches and other actions you take such as which features
              you use), device event information (such as system activity, error
              reports (sometimes called &quot;crash dumps&quot;) and hardware
              settings).
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <em>
              <span>Device Data.</span>
            </em>
            <span>
              {' '}
              We collect device data such as information about your computer,
              phone, tablet or other device you use to access the Services .
              Depending on the device used, this device data may include
              information such as your IP address (or proxy server), device and
              application identification numbers, location, browser type,
              hardware model Internet service provider and/or mobile carrier,
              operating system and system configuration information.
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <em>
              <span>Location Data.</span>
            </em>
            <span>
              {' '}
              We collect location data such as information about your
              device&apos;s location, which can be either precise or imprecise.
              How much information we collect depends on the type and settings
              of the device you use to access the Services . For example, we may
              use GPS and other technologies to collect geolocation data that
              tells us your current location (based on your IP address). You can
              opt out of allowing us to collect this information either by
              refusing access to the information or by disabling your Location
              setting on your device. Note however, if you choose to opt out,
              you may not be able to use certain aspects of the Services.
            </span>
          </li>
        </ul>

        <p>
          <strong>Information collected through our App</strong>
        </p>

        <p>
          <strong>
            <em>In Short:&nbsp; </em>
          </strong>
          <em>
            <span>
              We collect information regarding your mobile device, when you use
              our App.
            </span>
          </em>
        </p>

        <p>
          <span>
            If you use our App, we also collect the following information:
          </span>
        </p>
        <ul>
          <li>
            <em>
              <span>Mobile Device Data. </span>
            </em>
            <span>
              We automatically collect device information (such as your mobile
              device ID, model and manufacturer), operating system, version
              information and system configuration information, device and
              application identification numbers, browser type and version,
              hardware model Internet service provider and/or mobile carrier,
              and Internet Protocol (IP) address (or proxy server). If you are
              using our App, we may also collect information about the phone
              network associated with your mobile device, your mobile
              device&rsquo;s operating system or platform, the type of mobile
              device you use, your mobile device&rsquo;s unique device ID and
              information about the features of our App you accessed.
            </span>
          </li>
        </ul>
        <p>
          <span>
            This information is primarily needed to maintain the security and
            operation of our App, for troubleshooting and for our internal
            analytics and reporting purposes.
          </span>
        </p>

        <ol id="infouse" start={2}>
          <li>
            <strong> HOW DO WE USE YOUR INFORMATION?</strong>
          </li>
        </ol>

        <p>
          <strong>
            <em>In Short:&nbsp; </em>
          </strong>
          <em>
            <span>
              We process your information for purposes based on legitimate
              business interests, the fulfillment of our contract with you,
              compliance with our legal obligations, and/or your consent.
            </span>
          </em>
        </p>

        <p>
          <span>
            We use personal information collected via our Services for a variety
            of business purposes described below. We process your personal
            information for these purposes in reliance on our legitimate
            business interests, in order to enter into or perform a contract
            with you, with your consent, and/or for compliance with our legal
            obligations. We indicate the specific processing grounds we rely on
            next to each purpose listed below.
          </span>
        </p>

        <p>
          <span>We use the information we collect or receive:</span>
        </p>
        <ul>
          <li>
            <strong>To facilitate account creation and logon process.</strong>
            <span>
              {' '}
              If you choose to link your account with us to a third-party
              account (such as your Google or Facebook account), we use the
              information you allowed us to collect from those third parties to
              facilitate account creation and logon process for the performance
              of the contract.&nbsp; See the section below headed &quot;
            </span>
            <a href="#sociallogins">
              <span>HOW DO WE HANDLE YOUR SOCIAL LOGINS</span>
            </a>
            <span>&quot; for further information.</span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>To post testimonials.</strong>
            <span>
              {' '}
              We post testimonials on our Services that may contain personal
              information. Prior to posting a testimonial, we will obtain your
              consent to use your name and the content of the testimonial. If
              you wish to update, or delete your testimonial, please contact us
              at contact@drinkagenda.com and be sure to include your name,
              testimonial location, and contact information.
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>Request feedback. </strong>
            <span>
              We may use your information to request feedback and to contact you
              about your use of our Services .
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>To enable user-to-user communications.</strong>
            <span>
              {' '}
              We may use your information in order to enable user-to-user
              communications with each user&apos;s consent.
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>To manage user accounts. </strong>
            <span>
              We may use your information for the purposes of managing our
              account and keeping it in working order.
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>To send administrative information to you. </strong>
            <span>
              We may use your personal information to send you product, service
              and new feature information and/or information about changes to
              our terms, conditions, and policies.
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>To protect our Services. </strong>
            <span>
              We may use your information as part of our efforts to keep our
              Services safe and secure (for example, for fraud monitoring and
              prevention).
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>
              To enforce our terms, conditions and policies for business
              purposes, to comply with legal and regulatory requirements or in
              connection with our contract.
            </strong>
          </li>
        </ul>
        <ul>
          <li>
            <strong>To respond to legal requests and prevent harm. </strong>
            <span>
              If we receive a subpoena or other legal request, we may need to
              inspect the data we hold to determine how to respond.
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>Fulfill and manage your orders. </strong>
            <span>
              We may use your information to fulfill and manage your orders,
              payments, returns, and exchanges made through the Services .
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>Administer prize draws and competitions.</strong>
            <span>
              {' '}
              We may use your information to administer prize draws and
              competitions when you elect to participate in our competitions.
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>
              To deliver and facilitate delivery of services to the user.
            </strong>
            <span>
              {' '}
              We may use your information to provide you with the requested
              service.
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>
              To respond to user inquiries/offer support to users.
            </strong>
            <span>
              {' '}
              We may use your information to respond to your inquiries and solve
              any potential issues you might have with the use of our Services.
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>For other business purposes.</strong>
            <span>
              {' '}
              We may use your information for other business purposes, such as
              data analysis, identifying usage trends, determining the
              effectiveness of our promotional campaigns and to evaluate and
              improve our Services , products, marketing and your experience. We
              may use and store this information in aggregated and anonymized
              form so that it is not associated with individual end users and
              does not include personal information. We will not use
              identifiable personal information without your consent.
            </span>
          </li>
        </ul>

        <ol id="infoshare" start={3}>
          <li>
            <strong> WILL YOUR INFORMATION BE SHARED WITH ANYONE?</strong>
          </li>
        </ol>

        <p>
          <strong>
            <em>In Short:</em>
          </strong>
          <em>
            <span>
              &nbsp; We only share information with your consent, to comply with
              laws, to provide you with services, to protect your rights, or to
              fulfill business obligations.
            </span>
          </em>
        </p>

        <p>
          <span>
            We may process or share your data that we hold based on the
            following legal basis:
          </span>
        </p>
        <ul>
          <li>
            <strong>Consent:</strong>
            <span>
              {' '}
              We may process your data if you have given us specific consent to
              use your personal information for a specific purpose.
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>Legitimate Interests:</strong>
            <span>
              {' '}
              We may process your data when it is reasonably necessary to
              achieve our legitimate business interests.
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>Performance of a Contract:</strong>
            <span>
              {' '}
              Where we have entered into a contract with you, we may process
              your personal information to fulfill the terms of our contract.
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>Legal Obligations:</strong>
            <span>
              {' '}
              We may disclose your information where we are legally required to
              do so in order to comply with applicable law, governmental
              requests, a judicial proceeding, court order, or legal process,
              such as in response to a court order or a subpoena (including in
              response to public authorities to meet national security or law
              enforcement requirements).
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>Vital Interests:</strong>
            <span>
              {' '}
              We may disclose your information where we believe it is necessary
              to investigate, prevent, or take action regarding potential
              violations of our policies, suspected fraud, situations involving
              potential threats to the safety of any person and illegal
              activities, or as evidence in litigation in which we are involved.
            </span>
          </li>
        </ul>
        <p>
          <span>
            More specifically, we may need to process your data or share your
            personal information in the following situations:
          </span>
        </p>
        <ul>
          <li>
            <strong>Business Transfers.</strong>
            <span>
              {' '}
              We may share or transfer your information in connection with, or
              during negotiations of, any merger, sale of company assets,
              financing, or acquisition of all or a portion of our business to
              another company.
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <strong>Other Users. </strong>
            <span>
              When you share personal information (for example, by posting
              comments, contributions or other content to the Services ) or
              otherwise interact with public areas of the Services , such
              personal information may be viewed by all users and may be
              publicly made available outside the Services in perpetuity. If you
              interact with other users of our Services and register for our
              Services through a social network (such as Facebook), your
              contacts on the social network will see your name, profile photo,
              and descriptions of your activity. Similarly, other users will be
              able to view descriptions of your activity, communicate with you
              within our Services , and view your profile.
            </span>
          </li>
        </ul>

        <ol id="cookies" start={4}>
          <li>
            <strong> DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</strong>
          </li>
        </ol>

        <p>
          <strong>
            <em>In Short: </em>
          </strong>
          <em>
            <span>
              &nbsp;We may use cookies and other tracking technologies to
              collect and store your information.
            </span>
          </em>
        </p>

        <p>
          <span>
            We may use cookies and similar tracking technologies (like web
            beacons and pixels) to access or store information. Specific
            information about how we use such technologies and how you can
            refuse certain cookies is set out in our Cookie Notice .
          </span>
        </p>

        <ol id="sociallogins" start={5}>
          <li>
            <strong> HOW DO WE HANDLE YOUR SOCIAL LOGINS?</strong>
          </li>
        </ol>

        <p>
          <strong>
            <em>In Short:&nbsp; </em>
          </strong>
          <em>
            <span>
              If you choose to register or log in to our services using a social
              media account, we may have access to certain information about
              you.
            </span>
          </em>
        </p>

        <p>
          <span>
            Our Services offers you the ability to register and login using your
            third-party social media account details (like your Facebook or
            Twitter logins). Where you choose to do this, we will receive
            certain profile information about you from your social media
            provider. The profile Information we receive may vary depending on
            the social media provider concerned, but will often include your
            name, email address, friends list, profile picture as well as other
            information you choose to make public on such social media platform.
          </span>
        </p>

        <p>
          <span>
            We will use the information we receive only for the purposes that
            are described in this privacy notice or that are otherwise made
            clear to you on the relevant Services . Please note that we do not
            control, and are not responsible for, other uses of your personal
            information by your third-party social media provider. We recommend
            that you review their privacy notice to understand how they collect,
            use and share your personal information, and how you can set your
            privacy preferences on their sites and apps.
          </span>
        </p>

        <ol id="inforetain" start={6}>
          <li>
            <strong> HOW LONG DO WE KEEP YOUR INFORMATION?</strong>
          </li>
        </ol>

        <p>
          <strong>
            <em>In Short: </em>
          </strong>
          <em>
            <span>
              &nbsp;We keep your information for as long as necessary to fulfill
              the purposes outlined in this privacy notice unless otherwise
              required by law.
            </span>
          </em>
        </p>

        <p>
          <span>
            We will only keep your personal information for as long as it is
            necessary for the purposes set out in this privacy notice, unless a
            longer retention period is required or permitted by law (such as
            tax, accounting or other legal requirements). No purpose in this
            notice will require us keeping your personal information for longer
            than the period of time in which users have an account with us .
          </span>
        </p>

        <p>
          <span>
            When we have no ongoing legitimate business need to process your
            personal information, we will either delete or anonymize such
            information, or, if this is not possible (for example, because your
            personal information has been stored in backup archives), then we
            will securely store your personal information and isolate it from
            any further processing until deletion is possible.
          </span>
        </p>

        <ol id="infosafe" start={7}>
          <li>
            <strong> HOW DO WE KEEP YOUR INFORMATION SAFE?</strong>
          </li>
        </ol>

        <p>
          <strong>
            <em>In Short: </em>
          </strong>
          <em>
            <span>
              &nbsp;We aim to protect your personal information through a system
              of organizational and technical security measures.
            </span>
          </em>
        </p>

        <p>
          <span>
            We have implemented appropriate technical and organizational
            security measures designed to protect the security of any personal
            information we process. However, despite our safeguards and efforts
            to secure your information, no electronic transmission over the
            Internet or information storage technology can be guaranteed to be
            100% secure, so we cannot promise or guarantee that hackers,
            cybercriminals, or other unauthorized third parties will not be able
            to defeat our security, and improperly collect, access, steal, or
            modify your information. Although we will do our best to protect
            your personal information, transmission of personal information to
            and from our Services is at your own risk. You should only access
            the Services within a secure environment.
          </span>
        </p>

        <ol id="infominors" start={8}>
          <li>
            <strong> DO WE COLLECT INFORMATION FROM MINORS?</strong>
          </li>
        </ol>

        <p>
          <strong>
            <em>In Short:</em>
          </strong>
          <em>
            <span>
              &nbsp; We do not knowingly collect data from or market to children
              under 18 years of age.
            </span>
          </em>
        </p>

        <p>
          <span>
            We do not knowingly solicit data from or market to children under 18
            years of age. By using the Services , you represent that you are at
            least 18 or that you are the parent or guardian of such a minor and
            consent to such minor dependent&rsquo;s use of the Services . If we
            learn that personal information from users less than 18 years of age
            has been collected, we will deactivate the account and take
            reasonable measures to promptly delete such data from our records.
            If you become aware of any data we may have collected from children
            under age 18, please contact us at contact@drinkagenda.com.
          </span>
        </p>

        <ol id="privacyrights" start={9}>
          <li>
            <strong> WHAT ARE YOUR PRIVACY RIGHTS?</strong>
          </li>
        </ol>

        <p>
          <strong>
            <em>In Short:</em>
          </strong>
          <em>
            <span>
              &nbsp; You may review, change, or terminate your account at any
              time.
            </span>
          </em>
        </p>
        <p>
          <span>&nbsp;</span>
        </p>
        <p>
          <span>
            If you are a resident in the European Economic Area and you believe
            we are unlawfully processing your personal information, you also
            have the right to complain to your local data protection supervisory
            authority. You can find their contact details here:{' '}
          </span>
          <a href="http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm">
            <span>
              http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm
            </span>
          </a>
          <span>.</span>
        </p>

        <p>
          <span>
            If you are a resident in Switzerland, the contact details for the
            data protection authorities are available here:{' '}
          </span>
          <a href="https://www.edoeb.admin.ch/edoeb/en/home.html">
            <span>https://www.edoeb.admin.ch/edoeb/en/home.html</span>
          </a>
          <span>.</span>
        </p>

        <p>
          <span>
            If you have questions or comments about your privacy rights, you may
            email us at privacy@drinkagenda.com .
          </span>
        </p>

        <p>
          <strong>Account Information</strong>
        </p>

        <p>
          <span>
            If you would at any time like to review or change the information in
            your account or terminate your account, you can:
          </span>
        </p>
        <ul>
          <li>
            <span>
              Log in to your account settings and update your user account.
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <span>Contact us using the contact information provided.</span>
          </li>
        </ul>
        <p>
          <span>
            Upon your request to terminate your account, we will deactivate or
            delete your account and information from our active databases.
            However, we may retain some information in our files to prevent
            fraud, troubleshoot problems, assist with any investigations,
            enforce our Terms of Use and/or comply with applicable legal
            requirements.
          </span>
        </p>

        <p>
          <strong>Cookies and similar technologies:</strong>
          <span>
            {' '}
            Most Web browsers are set to accept cookies by default. If you
            prefer, you can usually choose to set your browser to remove cookies
            and to reject cookies. If you choose to remove cookies or reject
            cookies, this could affect certain features or services of our
            Services . To opt-out of interest-based advertising by advertisers
            on our Services visit{' '}
          </span>
          <a href="http://www.aboutads.info/choices/">
            <span>http://www.aboutads.info/choices/</span>
          </a>
          <span>.</span>
        </p>

        <p>
          <strong>Opting out of email marketing:</strong>
          <span>
            {' '}
            You can unsubscribe from our marketing email list at any time by
            clicking on the unsubscribe link in the emails that we send or by
            contacting us using the details provided below. You will then be
            removed from the marketing email list &mdash; however, we may still
            communicate with you, for example to send you service-related emails
            that are necessary for the administration and use of your account,
            to respond to service requests, or for other non-marketing purposes.
            To otherwise opt-out, you may:
          </span>
        </p>
        <ul>
          <li>
            <span>
              Access your account settings and update your preferences.
            </span>
          </li>
        </ul>
        <ul>
          <li>
            <span>Contact us using the contact information provided.</span>
          </li>
        </ul>

        <ol id="DNT" start={10}>
          <li>
            <strong> CONTROLS FOR DO-NOT-TRACK FEATURES</strong>
          </li>
        </ol>

        <p>
          <span>
            Most web browsers and some mobile operating systems and mobile
            applications include a Do-Not-Track (&quot;DNT&quot;) feature or
            setting you can activate to signal your privacy preference not to
            have data about your online browsing activities monitored and
            collected. At this stage no uniform technology standard for
            recognizing and implementing DNT signals has been finalized. As
            such, we do not currently respond to DNT browser signals or any
            other mechanism that automatically communicates your choice not to
            be tracked online. If a standard for online tracking is adopted that
            we must follow in the future, we will inform you about that practice
            in a revised version of this privacy notice.&nbsp;
          </span>
        </p>

        <ol id="caresidents" start={11}>
          <li>
            <strong>
              {' '}
              DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
            </strong>
          </li>
        </ol>

        <p>
          <strong>
            <em>In Short: </em>
          </strong>
          <em>
            <span>
              &nbsp;Yes, if you are a resident of California, you are granted
              specific rights regarding access to your personal information.
            </span>
          </em>
        </p>

        <p>
          <span>
            California Civil Code Section 1798.83, also known as the &quot;Shine
            The Light&quot; law, permits our users who are California residents
            to request and obtain from us, once a year and free of charge,
            information about categories of personal information (if any) we
            disclosed to third parties for direct marketing purposes and the
            names and addresses of all third parties with which we shared
            personal information in the immediately preceding calendar year. If
            you are a California resident and would like to make such a request,
            please submit your request in writing to us using the contact
            information provided below.
          </span>
        </p>

        <p>
          <span>
            If you are under 18 years of age, reside in California, and have a
            registered account with a Service , you have the right to request
            removal of unwanted data that you publicly post on the Services . To
            request removal of such data, please contact us using the contact
            information provided below, and include the email address associated
            with your account and a statement that you reside in California. We
            will make sure the data is not publicly displayed on the Services ,
            but please be aware that the data may not be completely or
            comprehensively removed from all our systems (e.g. backups, etc.).
          </span>
        </p>

        <ol id="policyupdates" start={12}>
          <li>
            <strong> DO WE MAKE UPDATES TO THIS NOTICE?</strong>
          </li>
        </ol>

        <p>
          <strong>
            <em>In Short: </em>
          </strong>
          <em>
            <span>
              &nbsp;Yes, we will update this notice as necessary to stay
              compliant with relevant laws.
            </span>
          </em>
        </p>

        <p>
          <span>
            We may update this privacy notice from time to time. The updated
            version will be indicated by an updated &quot;Revised&quot; date and
            the updated version will be effective as soon as it is accessible.
            If we make material changes to this privacy notice, we may notify
            you either by prominently posting a notice of such changes or by
            directly sending you a notification. We encourage you to review this
            privacy notice frequently to be informed of how we are protecting
            your information.
          </span>
        </p>

        <ol id="contact" start={13}>
          <li>
            <strong> HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</strong>
          </li>
        </ol>

        <p>
          <span>
            If you have questions or comments about this notice, you may contact
            our Data Protection Officer (DPO) at contact@drinkagenda.com.
          </span>
        </p>

        <ol id="request" start={14}>
          <li>
            <strong>
              {' '}
              HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM
              YOU?
            </strong>
          </li>
        </ol>

        <p>
          <span>
            Based on the applicable laws of your country, you may have the right
            to request access to the personal information we collect from you,
            change that information, or delete it in some circumstances. To
            request to review, update, or delete your personal information,
            please submit a request form by clicking{' '}
          </span>
          <a href="https://app.termly.io/notify/c46aee59-b0cf-41b5-b0d0-630d869e1bf3">
            <span>here</span>
          </a>{' '}
          <span>. We will respond to your request within 30 days.</span>
        </p>
        <p>
          <span>This privacy policy was created using </span>
          <a href="https://termly.io/products/privacy-policy-generator/?ftseo">
            <span>Termly&rsquo;s Privacy Policy Generator</span>
          </a>
          <span>.</span>
        </p>
      </div>
    </div>
  );
};
export default Privacy;
